<template>
    <div class="panel-container" :style="{'height': (documentClientHeight) + 'px'}">
        <el-row :gutter="40" class="panel-group card-block">
            <!-- 采购端和供应商端都显示 -->
            <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
                <el-card class="box-card" shadow="hover">
                    <div slot="header" class="clearfix">
                        <span><i class="el-icon-s-check icon-1"></i>我的待办</span>
                    </div>
                    <el-row class="">
                        <el-col :span="20">
                            <div class="icon-tip-num">
                                <span>{{this.dealtCount}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
          <!-- 替换整个QMS待办卡片 -->
          <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col" v-if="this.userTypeId == 5">
            <el-card class="box-card" shadow="hover" @click.native="navigateToQms" style="cursor: pointer;">
              <div slot="header" class="clearfix">
                <span><i class="el-icon-s-management icon-2"></i>QMS待办</span>
              </div>
              <el-row class="">
                <el-col :span="20">
                  <div class="icon-tip-num">
                    <span>{{this.qmsDealtCount}}</span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <!-- 仅供应商端显示 -->
            <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col" v-if="this.userTypeId == 5">
                <el-card class="box-card" shadow="hover">
                    <div slot="header" class="clearfix">
                        <span><i class="el-icon-s-opportunity icon-1"></i>操作手册</span>
                    </div>
                    <el-row>
                        <el-col :span="20" align="center">
                            <el-button icon="el-icon-download" type="success" @click="downloadfiles()">点击下载</el-button>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <!-- 仅供应商端显示 -->
            <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col" v-if="this.userTypeId == 5">
                <el-card class="box-card" shadow="hover">
                    <div slot="header" class="clearfix">
                        <span><i class="el-icon-phone icon-1"></i>通告</span>
                    </div>
                    <el-table :data="noticeDataList">
                        <el-table-column
                                prop="noticeType"
                                header-align="center"
                                align="center"
                                width="120px"
                                :formatter="noticeTypeFormat"
                                label="类型">
                        </el-table-column>
                        <el-table-column
                                prop="noticeTitle"
                                header-align="center"
                                align="center"
                                width="300px"
                                label="标题">
                        </el-table-column>
                        <el-table-column
                                prop="noticeContent"
                                header-align="center"
                                align="center"
                                label="内容">
                            <template slot-scope="scope">
                                <el-button type="" v-if="scope.row.noticeStatus == 0" size="small" @click="dialogNoticeContent(scope.row)">点击查看内容</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="createTime"
                                header-align="center"
                                align="center"
                                width="180px"
                                label="创建时间">
                        </el-table-column>
                    </el-table>
                    <el-pagination @size-change="sizeChangeHandleNotice" @current-change="currentChangeHandleNotice" :current-page="pageIndexNotice" :page-sizes="[3]" :page-size="pageSizeNotice" :total="totalPageNotice" layout="total, sizes, prev, pager, next, jumper">
                    </el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <!-- 待办列表（采购端和供应商端都显示） -->
        <el-table
                :data="dataList"
                v-loading="dataListLoading"
                size="small"
                stripe
                @selection-change="selectionChangeHandle"
                :height="540"
                style="width: 100%;">
            <el-table-column
                    type="index"
                    width="50"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="taskName"
                    header-align="left"
                    align="left"
                    label="名称">
            </el-table-column>
            <el-table-column
                    prop="processName"
                    header-align="left"
                    align="left"
                    label="相关流程">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    header-align="left"
                    align="left"
                    label="创建时间">
            </el-table-column>
            <el-table-column
                    header-align="left"
                    align="left"
                    width="300"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="executeHandle(scope.row)" icon="el-icon-edit">处理
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-show="totalPage>0"
            style="text-align: center"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>

        <!-- 弹窗的通知公告 -->
        <el-dialog title="通知公告" :visible.sync="showContent" width="">
            <el-form :model="dataForm" label-width="50px">
                <el-tabs>
                    <el-tab-pane class="tab_style" :key="1" label="通告信息" style="min-height: 42vh;">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="标题" prop="dialogTitle">
                                    <el-input v-model="dialogTitle" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="内容" prop="dialogContent">
                                    <el-input type="textarea" v-model="dialogContent" :rows="10" disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane class="tab_style" :key="2" label="附件文件">
                        <FileUpDown ref="FileUpDown" :bizId="this.noticeId" :viewFlag="'view'" :bizType="FILE_BIZ_TYPE"></FileUpDown>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
        </el-dialog>

        <!-- 操作手册的弹出层 -->
        <el-dialog title="操作手册" :visible.sync="fileFlag" :close-on-click-modal="false" :append-to-body="true" :close-on-press-escape="false" width="45%">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="rowId" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="fileRemark" label="说明" width="180"></el-table-column>
                <el-table-column prop="originalName" label="文件链接" width="360">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleDownload(scope.row)"> {{ scope.row.originalName }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import {getUserInfoByToken} from '@/controller/sys'
    import {listNotice,qmsTodoCount,qmsUrlData} from '@/controller/supplier'
    import {countCodeApplyMyToDo, listCodeApplyMyToDo} from '@/controller/supplier'
    import FileUpDown from "@/views/common/file-up-down";
    import {
        countToDo, 
        listMyToDo,
        fetchTodoList
    } from '@/controller/workflow'
    export default {
        name: 'PanelIndex',
        data() {
            //this.getExamineCount();
            this.getUserInfo();
            return {
                urlData:'',
                qmsDealtCount: '0',
                noticeDataList:[],
                noticeDataListLoading: false,
                showContent: false,
                noticeId:'',
                FILE_BIZ_TYPE:18,
                dialogTitle: '',
                dialogContent: '',
                fileFlag: false,
                tableData: [
                    {
                        id: 319,
                        url:'doc/SRM操作手册.zip',
                        rowId: 1,
                        originalName: 'SRM操作手册.zip',
                        fileRemark: 'SRM操作手册'
                    }
                ],
                documentClientHeight: document.documentElement['clientHeight'],
                dealtCount: 0,
                userTypeId: '',
                loginName: '',
                dataForm: {
                    code: '',
                    name: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                pageIndexNotice:1,
                pageSizeNotice:3,
                totalPageNotice:0,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                menuUpdateVisible: false
            }
        },
        components: {
            FileUpDown, //上传附件
        },
        methods:{
          navigateToQms() {
            console.log('跳转到QMS待办页面');
            qmsUrlData({})
                .then(data => {
                  if (data && data.code === '00') {
                    this.urlData = data.body
                    // 拼接完整URL并跳转
                    const baseUrl = 'https://qms.wqnev.com/#/supplierBacklog?supplierCode=';
                    const fullUrl = baseUrl + this.urlData;
                    // 实现跳转
                    window.open(fullUrl, '_blank');
                  } else {
                    this.$message.error(data.msg)
                  }
                })

          },
          getQmsExamineCount() {
            qmsTodoCount({},this.loginName)
                .then(data => {
                  if (data && data.code === '00') {
                    this.qmsDealtCount = data.body
                  } else {
                    this.$message.info(data.msg)
                  }
            })
          },
            noticeTypeFormat (row) {
                return row.noticeType=='0'? '通知' : '供应商绩效通知'
            },
            dialogNoticeContent(row) {
                this.noticeId = row.id;
                this.showContent = true;
                this.dialogTitle = row.noticeTitle;
                this.dialogContent = row.noticeContent;
                this.$nextTick(() => {
                    this.$refs.FileUpDown.init('view')
                }) 
            },
            // 获取公告列表——3条倒序
            getDataList() {
                this.noticeDataListLoading = true;
                listNotice(
                {
                    'pageNo': this.pageIndexNotice,
                    'pageSize': this.pageSizeNotice
                }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.noticeDataList = data.body.records
                        this.totalPageNotice = data.body.total
                        // this.dealtCount = data.body.total
                    } else {
                        this.noticeDataList = []
                    }
                    this.noticeDataListLoading = false;
                })
            },
            downloadfiles() {
                this.fileFlag = true
            },
            handleDownload(row) {
                this.download(row.url, row.originalName)
            },
            download(url, filename) {
              const _this = this
              this.getBlob(url, function(blob) {
                _this.saveAs(blob, filename);
              });
            },
            getBlob(url, cb) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "blob";
              xhr.onload = function() {
                if (xhr.status === 200) {
                  cb(xhr.response);
                }
              };
              xhr.send();
            },
            saveAs(blob, filename) {
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
              } else {
                var link = document.createElement("a");
                var body = document.querySelector("body");

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                // fix Firefox
                link.style.display = "none";
                body.appendChild(link);

                link.click();
                body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
              }
            },
            // 操作处理
            executeHandle(row) {
                if(this.userTypeId == 5) {
                    this.$router.push('/portal-basicInfo')
                } else {
                    // 定厂审批单
                    if(row.processKey === 'FIX_POINT_APPROVE2025'){
                        this.$router.push('/sourcing-audit')
                    }
                    // 价格协议审批
                    else if(row.processKey === 'PAA'){
                        this.$router.push('/sourcing-priceAgreement')
                    }
                    // 潜在供应商准入
                    else if(row.processKey === 'PSA'){
                        this.$router.push('/supplier-admissionApplyForm')
                    }
                    // 合格供应商准入
                    else if(row.processKey === 'QSA1'){
                        this.$router.push('/supplier-admissionApplyForm2')
                    }
                    // 样件订单审批
                    else if(row.processKey === 'SAMPLE_ORDER'){
                        this.$router.push('/sourcing-order')
                    }
                    // 供应商编码申请
                    else if(row.processKey === 'SCA'){
                        this.$router.push('/supplier-qualifiedCodeApprove')
                    }
                    // 供应商编码申请
                    else if(row.processKey === 'SCA1'){
                      this.$router.push('/supplier-qualifiedCodeApprove')
                    }
                    else if(row.processKey === 'SCA0'){
                        this.$router.push('/supplier-qualifiedCodeApply')
                    }
                    // 供应商变更审批
                    else if(row.processKey === 'SCI'){
                        this.$router.push('/supplier-changeApprove')
                    }
                    else if(row.processKey === 'SCI0'){
                      this.$router.push('/supplier-changeApprove')
                    }
                    // 供应商冻结审批
                    else if(row.processKey === 'SUPPLIER_FREEZE2025'){
                        if(row.taskName === '提交供应商冻结申请'){
                            this.$router.push('/supplier-supplierInfo')
                        }else{
                            this.$router.push('/supplier-freezingThawApplyForm')
                        }
                    }
                    // 供应商解冻审批
                    else if(row.processKey === 'SUPPLIER_THAW2025'){
                        if(row.taskName === '提交供应商解冻申请'){
                            this.$router.push('/supplier-supplierInfo')
                        }else{
                            this.$router.push('/supplier-thawApplyForm')
                        }
                    }
                    // 交货单审批
                    else if(row.processKey === 'DOA'){
                        this.$router.push('/sop-delivery')
                    }
                    else if(row.processKey === 'SYP'){
                        this.$router.push('/supplier-inExitApplyForm')
                    }
                    else if(row.processKey === 'SNP'){
                      this.$router.push('/supplier-inExitExitApplyForm')
                    }
                    else if(row.processKey === 'SNB'){
                      this.$router.push('/supplier-isBlackExitApplyForm')
                    }
                    else if(row.processKey === 'SYB'){
                      this.$router.push('/supplier-isBlackApplyForm')
                    }
                    else if(row.processKey === 'QMA'){
                      this.$router.push('/mdata-quotaApprove')
                    }
                }
            },
            // 获取我的待办个数——【供应商代码审批 要单独补充】
            getExamineCount() {
                countToDo().then((data) => {
                    if(data && data.code === '00') {
                        this.dealtCount = data.body;

                        countCodeApplyMyToDo({}).then(data => {
                            if(data && data.code === '00'){
                                this.dealtCount = this.dealtCount + data.body;
                            }
                        })
                    } else {
                        this.dealtCount = 0
                    }
                })
            },
            getUserInfo() {
                getUserInfoByToken().then((data) =>{
                    if(data && data.code === '00') {
                        this.userTypeId = data.body.user.typeId
                        this.loginName = data.body.user.loginName
                        if(this.userTypeId && this.userTypeId == '1') {
                            this.dealtCount = 0
                            this.dataList = []
                        } else {
                            if(this.userTypeId && this.userTypeId != '5') {
                                // 采购
                                this.getExamineList()
                            } else {
                                // 供应商
                                this.getDataList()
                                this.getSupplierExamineList()
                                this.getQmsExamineCount()
                            }
                        }
                    }
                })
            },
            // 获取供应商待办列表
            getSupplierExamineList() {
                this.dataListLoading = true
                fetchTodoList({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 获取采购人员待办列表——【供应商代码审批 要单独补充】
            getExamineList() {
                this.dataListLoading = true
                if(this.userTypeId && this.userTypeId === '1') {
                    this.dealtCount = 0
                    this.dataListLoading = false
                    return ''
                }
                listMyToDo({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                        this.dealtCount = data.body.total
                        listCodeApplyMyToDo({}).then(data => {
                            if(data && data.code === '00'){
                                if(data.body.length != 0){
                                    this.dataList = this.dataList.concat(data.body)
                                    this.dealtCount = this.dealtCount + data.body.length
                                }
                            } else {
                                this.dataList = []
                                this.totalPage = 0
                            }
                        })

                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })

            },
            // 每页数
            sizeChangeHandleNotice(val) {
                this.pageSizeNotice = val
                this.pageIndexNotice = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandleNotice(val) {
                this.pageIndexNotice = val
                this.getDataList()
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                if(this.userTypeId && this.userTypeId == '1') {
                    this.dealtCount = 0
                    this.dataList = []
                } else {
                    if(this.userTypeId && this.userTypeId != '5') {
                        this.getExamineList()
                    } else {
                        this.getSupplierExamineList()
                    }
                }
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                if(this.userTypeId && this.userTypeId == '1') {
                    this.dealtCount = 0
                    this.dataList = []
                } else {
                    if(this.userTypeId && this.userTypeId != '5') {
                        this.getExamineList()
                    } else {
                        this.getSupplierExamineList()
                    }
                }
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
        }
    }
</script>

<style lang="scss">
    .box-card{
        .el-card__header{
            span{
                i{
                    margin-right: 5px;
                }
            }
            .icon-1 {
                color: #40c9c6;
            }

            .icon-2 {
                color: #36a3f7;
            }

            .icon-3 {
                color: #f4516c;
            }

            .icon-4 {
                color: #34bfa3
            }
        }
    }
    .panel-item{
        font-size: 14px;
        padding: 5px 0;
    }
    .icon-tip-num {
        text-align: center;
        margin: 2px;
        color: #36a3f7;
        font-size: 32px;
    }
    .panel-container {
        /*padding: 32px;*/
        /*background-color: rgb(240, 242, 245);*/
        position: relative;
        height: 100%;
    }

    .card-block{
        .card-panel-col {
            padding-right: 0px !important;
            padding-left: 10px !important;
        }
        .card-panel-col:last-child{
            padding-right: 20px !important;
        }
        .card-panel-col:first-child{
            padding-left: 20px !important;
        }
    }

    .panel-group {
        /*margin-top: 18px;*/

        .card-panel-col {
            margin: 0 0 10px 0;
        }

        .card-panel {
            height: 108px;
            cursor: pointer;
            font-size: 12px;
            position: relative;
            overflow: hidden;
            color: #666;
            background: #fff;
            box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
            border-color: rgba(0, 0, 0, .05);
            border-radius: 3px;

            i {
                font-size: 40px;
            }

            &:hover {
                .card-panel-icon-wrapper {
                    color: #fff;
                }

                .icon-1 {
                    background: #40c9c6;
                }
                .icon-3 {
                    background: #f4516c;
                }

                .icon-4 {
                    background: #34bfa3
                }
            }

            .card-panel-icon-wrapper {
                float: left;
                margin: 14px 0 0 14px;
                padding: 16px;
                transition: all 0.38s ease-out;
                border-radius: 6px;
            }

            .card-panel-icon {
                float: left;
                font-size: 48px;
            }

            .card-panel-description {
                float: right;
                font-weight: bold;
                margin: 26px;
                margin-left: 0px;

                .card-panel-text {
                    line-height: 18px;
                    color: rgba(0, 0, 0, 0.45);
                    font-size: 16px;
                    margin-bottom: 12px;
                }

                .card-panel-num {
                    font-size: 20px;
                }
            }
        }
    }
</style>
